import { JetView } from 'webix-jet'; // Importing JetView from webix-jet framework
import { allpayments } from 'models/allpayments'; // Importing allpayments model
import { devConfig } from 'config/config'; // Importing development configuration

/**
 * Class representing the table deposit report view.
 * @extends JetView
 */
export default class tableDepositReportView extends JetView {
    /**
     * Configures the UI components of the view.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service
        const dateFormat = webix.Date.dateToStr(this.app.config.dateFormat); // Date formatting function

        // Extending the summTreeColumn filter for custom summation behavior
        webix.ui.datafilter.summTreeColumn = webix.extend(
            {
                refresh: function (master, node, value) {
                    var result = 0; // Variable to hold the summation result
                    var resultFormat = 0; // Variable for formatted result
                    master.data.each(function (obj) {
                        if (obj.$level == 1) result += obj[value.columnId]; // Summing values at level 1
                    });
                    // Formatting the result based on the column ID
                    if (value.columnId === 'CantidadTickets') {
                        resultFormat = webix.i18n.intFormat(result);
                    } else {
                        resultFormat = webix.i18n.priceFormat(result);
                    }
                    node.firstChild.innerHTML = resultFormat; // Updating the node with the formatted result
                },
            },
            webix.ui.datafilter.summColumn, // Extending from the existing summColumn filter
        );
        return {
            rows: [
                {
                    id: 'preloader', // ID for the preloader element
                    cols: [
                        {
                            view: 'treetable', // Treetable component for displaying hierarchical data
                            id: 'treetable', // ID for the treetable
                            css: 'webix_header_border webix_data_border webix_footer_border', // CSS classes for styling
                            bready: function () {
                                this.openAll(); // Function to open all rows in the treetable
                            },
                            select: true, // Enable row selection
                            scrollY: screen.width < 820 ? false : true, // Conditional vertical scrolling based on screen width
                            columns: [
                                {
                                    id: 'Date', // Column ID for date
                                    header: _('Fecha'), // Column header with localization
                                    width: 240, // Column width
                                    template: function (obj, common) {
                                        if (obj.$group)
                                            return (
                                                common.treetable(obj, common) + obj.value // Display group value if it's a group row
                                            );
                                        return obj.Date; // Return date for regular rows
                                    },
                                    footer: _('Total:'), // Footer text for the column
                                },
                                {
                                    id: 'Action', // Column ID for action
                                    header: '', // No header for action column
                                    width: 70, // Column width
                                    height: 25, // Column height
                                    tooltip: _('Acción'), // Tooltip for action column
                                    hidden: !devConfig.getPermAction(
                                        'torefuseTransactionBetShop',
                                        'Torefuse', // Conditional visibility based on permissions
                                    ) && !devConfig.getPermAction(
                                        'reprintTransactionBetShop',
                                        'Torefuse', // Conditional visibility based on permissions
                                    ),
                                    template: function (obj) {
                                        let buttons = "";
                                        if (
                                            obj.AllowCancelTransaction == true // Check if transaction can be canceled
                                        ) {
                                            if (
                                                devConfig.getPermAction(
                                                    'torefuseTransactionBetShop',
                                                    'Torefuse', // Check for permission to refuse transaction
                                                )
                                            ) {
                                                buttons += "<span class='webix_icon wxi-close torefuse prm-torefuseTransactionBetShop'></span>";
                                                // Return refuse icon
                                            }
                                        }
                                        if((obj.Vertical == "virtual")){
                                            if (devConfig.getPermAction("reprintTransactionBetShop", "Add")) {
                                                buttons += `
                                                <span class="reprint-ticket prm-reprintTransactionBetShop" title="Reimprimir" style="cursor:pointer; display:inline-flex; align-items:center; justify-content:center;">
                                                  <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                                                    <path d="M19 8H5c-1.1 0-2 .9-2 2v6h4v4h10v-4h4v-6c0-1.1-.9-2-2-2zM17 18H7v-5h10v5zM17 3H7v3h10V3z"/>
                                                  </svg>
                                                </span>
                                              `;
                                            }
                                        }

                                        return buttons; // Return empty if no action is available
                                    },
                                },
                                {
                                    id: 'Hour', // Column ID for hour
                                    header: _('Hora'), // Column header with localization
                                    width: 200, // Column width
                                    sort: 'int', // Sorting type
                                },
                                {
                                    id: 'NoTicket', // Column ID for ticket number
                                    header: _('No. Ticket'), // Column header with localization
                                    width: 150, // Column width
                                    sort: 'int', // Sorting type
                                },
                                {
                                    id: "ClienteIdDinamico", // Column ID for client id
                                    header: _("ID Cliente"), // Column header with localization
                                    width: 100, // Column width
                                    sort: "string" // Sorting type
                                },
                                {
                                    id: "TicketIdProveedor", // Column ID for ticket id
                                    header: _("ID Virtuales"), // Column header with localization
                                    width: 120, // Column width
                                    sort: "string", // Sorting type
                                    exportType: "string" // Export type for this column
                                },
                                {
                                    id: 'FormaPago1', // Column ID for payment method 1
                                    header: _('Forma Pago 1'), // Column header with localization
                                    width: 150, // Column width
                                    sort: 'int', // Sorting type
                                },
                                {
                                    id: 'PagoBonoTC', // Column ID for bonus payment / T.C.
                                    header: _('Pago Bono / T.C.'), // Column header with localization
                                    format: webix.i18n.priceFormat, // Formatting function for price
                                    exportType: 'number', // Export type for this column
                                    width: 150, // Column width
                                    sort: 'int', // Sorting type
                                },
                                {
                                    id: 'ValorEntradasEfectivo', // Column ID for cash entry value
                                    header: _('Valor Entradas Efectivo'), // Column header with localization
                                    footer: { content: 'summTreeColumn' }, // Footer content using custom filter
                                    format: webix.i18n.priceFormat, // Formatting function for price
                                    exportType: 'number', // Export type for this column
                                    width: 200, // Column width
                                    sort: 'int', // Sorting type
                                },
                                {
                                    id: 'ValorEntradasBonoTC', // Column ID for bonus entry value / T.C.
                                    header: _('Valor Entradas Bono / T.C.'), // Column header with localization
                                    footer: { content: 'summTreeColumn' }, // Footer content using custom filter
                                    format: webix.i18n.priceFormat, // Formatting function for price
                                    exportType: 'number', // Export type for this column
                                    width: 200, // Column width
                                    sort: 'int', // Sorting type
                                },
                                {
                                    id: 'ValorEntradasTraslados', // Column ID for transfer entry value
                                    header: _('Valor Entradas Traslados'), // Column header with localization
                                    footer: { content: 'summTreeColumn' }, // Footer content using custom filter
                                    format: webix.i18n.priceFormat, // Formatting function for price
                                    exportType: 'number', // Export type for this column
                                    width: 200, // Column width
                                    sort: 'int', // Sorting type
                                },
                                {
                                    id: 'ValorEntradasRecargas', // Column ID for recharge entry value
                                    header: _('Valor Entradas Recargas'), // Column header with localization
                                    footer: { content: 'summTreeColumn' }, // Footer content using custom filter
                                    format: webix.i18n.priceFormat, // Formatting function for price
                                    exportType: 'number', // Export type for this column
                                    width: 200, // Column width
                                    sort: 'int', // Sorting type
                                },
                                {
                                    id: 'ValorEntradasRecargasAgentes', // Column ID for agent recharge entry value
                                    hidden: devConfig.getPartnerSelected() == 1 || devConfig.getPartnerSelected() == 2, // Conditional visibility based on partner selection
                                    header: _(
                                        'Valor Entradas Recargas Agentes', // Column header with localization
                                    ),
                                    footer: { content: 'summTreeColumn' }, // Footer content using custom filter
                                    format: webix.i18n.priceFormat, // Formatting function for price
                                    exportType: 'number', // Export type for this column
                                    width: 200, // Column width
                                    sort: 'int', // Sorting type
                                },
                                {
                                    id: 'DevolucionRecargas', // Column ID for canceled recharges
                                    header: _('Recargas Anuladas'), // Column header with localization
                                    footer: { content: 'summTreeColumn' }, // Footer content using custom filter
                                    format: webix.i18n.priceFormat, // Formatting function for price
                                    exportType: 'number', // Export type for this column
                                    width: 142, // Column width
                                    sort: 'int', // Sorting type
                                },
                                {
                                    id: 'ValorSalidasEfectivo', // Column ID for cash exit value
                                    header: _('Valor Salidas Efectivo'), // Column header with localization
                                    footer: { content: 'summTreeColumn' }, // Footer content using custom filter
                                    format: webix.i18n.priceFormat, // Formatting function for price
                                    exportType: 'number', // Export type for this column
                                    width: 200, // Column width
                                    sort: 'int', // Sorting type
                                },
                                {
                                    id: 'ValorSalidasTraslados', // Column ID for transfer exit value
                                    header: _('Valor Salidas Traslados'), // Column header with localization
                                    footer: { content: 'summTreeColumn' }, // Footer content using custom filter
                                    format: webix.i18n.priceFormat, // Formatting function for price
                                    exportType: 'number', // Export type for this column
                                    width: 200, // Column width
                                    sort: 'int', // Sorting type
                                },
                                {
                                    id: 'ValorSalidasNotasRetiro', // Column ID for withdrawal note exit value
                                    header: _('Valor Salidas Notas de Retiro'), // Column header with localization
                                    footer: { content: 'summTreeColumn' }, // Footer content using custom filter
                                    format: webix.i18n.priceFormat, // Formatting function for price
                                    exportType: 'number', // Export type for this column
                                    width: 300, // Column width
                                    sort: 'int', // Sorting type
                                },
                                {
                                    id: 'Saldo', // Column ID for balance
                                    header: _('Saldo'), // Column header with localization
                                    format: webix.i18n.priceFormat, // Formatting function for price
                                    exportType: 'number', // Export type for this column
                                    width: 150, // Column width
                                    footer: { content: 'summTreeColumn' }, // Footer content using custom filter
                                    sort: 'int', // Sorting type
                                },
                                {
                                    id: 'Moneda', // Column ID for currency
                                    header: _('Moneda'), // Column header with localization
                                    width: 150, // Column width
                                    sort: 'int', // Sorting type
                                },
                            ],
                            onClick: {
                                torefuse: function (euv, id) {
                                    var vvthis = this; // Reference to the current context
                                    webix.confirm({
                                        type: 'confirm-warning', // Confirmation dialog type
                                        text: _('Advertencia!') + '<br/>' + _('Desea cancelar transacción?'), // Confirmation message
                                        ok: _('Aceptar'), // OK button text
                                        cancel: _('Salir'), // Cancel button text
                                        callback: function (action) {
                                            if (action === true) {
                                                var item = vvthis.getItem(id); // Get the clicked item
                                                if (item.AllowCancelTransaction) {
                                                    webix
                                                        .ajax()
                                                        .headers({
                                                            'Content-type': 'application/json', // Set content type for AJAX request
                                                        })
                                                        .post(
                                                            devConfig.geturlApi() + 'es/Financial/CancelTransaction',
                                                            '{ "Id":' + item.Id + '}', // Payload for cancel transaction
                                                            {
                                                                error: function (text, data, XmlHttpRequest) {
                                                                    webix.message(
                                                                        _(
                                                                            'Error! ', // Error message on failure
                                                                        ),
                                                                    );
                                                                },
                                                                success: function (text, data, XmlHttpRequest) {
                                                                    item.AllowCancelTransaction = false; // Disable cancel action after successful cancellation
                                                                    webix.message(
                                                                        _(
                                                                            'Transacción cancelada', // Success message
                                                                        ),
                                                                    );
                                                                    vvthis.$$('datatable').refresh(); // Refresh the datatable
                                                                },
                                                            },
                                                        );
                                                } else {
                                                    webix.message({
                                                        text: _(
                                                            'Esta transacción no permite ser cancelada', // Error message if transaction cannot be canceled
                                                        ),
                                                        title: _('¡Error!'), // Title for error message
                                                        type: 'alert-error', // Type of message
                                                    });
                                                }
                                            }
                                        },
                                    });
                                },
                                "reprint-ticket": function (e, id) {
                                    const vvthis = this; // Reference to the current context
                                    const item = vvthis.getItem(id); // Get the clicked item

                                    // Show a confirmation dialog for reprinting the virtual bet ticket
                                    webix.confirm({
                                        type: "confirm-info", // Confirmation dialog type
                                        text: _("¿Reimprimir ticket de apuesta virtual?"), // Confirmation message
                                        ok: _("Sí"), // OK button text
                                        cancel: _("No"), // Cancel button text
                                        callback: yes => {
                                            if (!yes) return; // Exit if the user cancels

                                            // Construct the URL for fetching the virtual bet ticket
                                            const url = devConfig.geturlApi() + "es/UserManagement/GetBetVirtual" +
                                                `?userPv=${encodeURIComponent(item.PuntoId)}` + // Encode the point ID
                                                `&ticketId=${encodeURIComponent(item.TicketIdApuestaVirtual)}` + // Encode the ticket ID
                                                `&userId=${encodeURIComponent(item.ClienteIdPlataforma)}`; // Encode the user ID

                                            // Make an AJAX GET request to fetch the ticket data
                                            webix.ajax()
                                                .headers({ "Content-type": "application/json" }) // Set the request headers
                                                .get(
                                                    url,
                                                    (text, data, xhr) => {
                                                        const response = JSON.parse(text); // Parse the response JSON

                                                        // Helper function to convert a base64 string to a Blob
                                                        function base64ToBlob(base64, mime) {
                                                            const bin = atob(base64); // Decode the base64 string
                                                            const arr = new Uint8Array(bin.length); // Create a byte array
                                                            for (let i = 0; i < bin.length; i++) {
                                                                arr[i] = bin.charCodeAt(i); // Populate the byte array
                                                            }
                                                            return new Blob([arr], { type: mime }); // Return the Blob
                                                        }

                                                        // Convert the base64-encoded PDFs to Blob objects
                                                        const blobTicket = base64ToBlob(response.Pdf, 'application/pdf');
                                                        const blobPOS = base64ToBlob(response.PdfPOS, 'application/pdf');

                                                        // Create object URLs for the PDFs
                                                        const urlTicket = URL.createObjectURL(blobTicket);
                                                        const urlPOS = URL.createObjectURL(blobPOS);

                                                        // Display the PDFs in a Webix window
                                                        webix.ui({
                                                            view: "window", id: "pdfViewerWindow", modal: true, // Modal window
                                                            move: true, height: 600, width: 800, position: "center", // Window dimensions and position
                                                            head: {
                                                                view: "toolbar", cols: [
                                                                    { view: "button", value: "Ticket", width: 100, click() {
                                                                            // Show the ticket PDF in the iframe
                                                                            $$("pdfViewerFrame").setHTML(
                                                                                `<iframe src="${urlTicket}" style="width:100%;height:100%" frameborder="0">`
                                                                            );
                                                                        }},
                                                                    { view: "button", value: "POS", width: 100, click() {
                                                                            // Show the POS PDF in the iframe
                                                                            $$("pdfViewerFrame").setHTML(
                                                                                `<iframe src="${urlPOS}" style="width:100%;height:100%" frameborder="0">`
                                                                            );
                                                                        }},
                                                                    { view: "label", label: "Visualizador de PDF", align: "center" }, // Window title
                                                                    { view: "icon", icon: "wxi-close", click() {
                                                                            this.getTopParentView().close(); // Close the window
                                                                        }}
                                                                ]
                                                            },
                                                            body: {
                                                                id: "pdfViewerFrame", // ID for the iframe container
                                                                template: `<iframe src="${urlTicket}" style="width:100%;height:100%" frameborder="0">` // Default content
                                                            }
                                                        }).show(); // Show the window
                                                    },
                                                    () => {
                                                        // Show an error message if the request fails
                                                        webix.message({
                                                            type: "error",
                                                            text: _("Error al obtener el PDF para reimpresión")
                                                        });
                                                    }
                                                );
                                        }
                                    });
                                },
                            },
                            on: {
                                onBeforeLoad: function () {
                                    this.showOverlay(
                                        "<div id='contenedor'; class='container-preload'><div style='position: fixed; top: calc(50% - 57px);left: calc(50% - 60px);width: 120px;' class='progress'><div class='icon-preload girando'></div><div class='load-text'>Loading... </div></div></div>", // Show loading overlay before data load
                                    );
                                },
                                onAfterLoad: function () {
                                    this.hideOverlay(); // Hide loading overlay after data load
                                },
                            },
                            ready: function () {
                                if (!this.count()) {
                                    webix.extend(this, webix.OverlayBox); // Extend with overlay capabilities
                                    this.showOverlay(
                                        "<div class='no-data' style='margin:75px; font-size:18px;'>" +
                                            _('No hay datos') + // Show no data message
                                            '</div>',
                                    );
                                }
                            },
                            autowidth: false, // Disable automatic width adjustment
                            math: true, // Enable mathematical operations
                            loadahead: devConfig.getDefaultDataFetch(), // Set data fetch strategy
                            pager: 'pagerA', // ID for the pager component
                            leftSplit: screen.width > 500 ? 1 : 0, // Conditional left split based on screen width
                        },
                    ],
                },
            ],
        };
    }

    /**
     * Initializes the view and sets up event handlers.
     * @param {Object} grid - The grid component to initialize.
     */
    init(grid) {
        grid = $$('treetable'); // Reference to the treetable component
        var url = devConfig.geturlApi() + 'es/Financial/GetFlujoCaja'; // API endpoint for fetching data
        grid.attachEvent('onAfterLoad', function () {
            $$('treetable').data.group({
                by: 'Punto', // Grouping by 'Punto'
                map: {
                    Punto: ['Punto'],
                    Action: ['Action'],
                    ValorEntradasEfectivo: ['ValorEntradasEfectivo', 'sum'], // Summing cash entry values
                    ValorEntradasBonoTC: ['ValorEntradasBonoTC', 'sum'], // Summing bonus entry values
                    ValorEntradasTraslados: ['ValorEntradasTraslados', 'sum'], // Summing transfer entry values
                    ValorEntradasRecargas: ['ValorEntradasRecargas', 'sum'], // Summing recharge entry values
                    ValorEntradasRecargasAgentes: [
                        'ValorEntradasRecargasAgentes',
                        'sum', // Summing agent recharge values
                    ],
                    DevolucionRecargas: ['DevolucionRecargas', 'sum'], // Summing canceled recharges
                    ValorSalidasEfectivo: ['ValorSalidasEfectivo', 'sum'], // Summing cash exit values
                    ValorSalidasTraslados: ['ValorSalidasTraslados', 'sum'], // Summing transfer exit values
                    ValorSalidasNotasRetiro: ['ValorSalidasNotasRetiro', 'sum'], // Summing withdrawal note exit values
                    Saldo: ['Saldo', 'sum'], // Summing balance values
                    PagoBonoTC: ['PagoBonoTC', 'sum'], // Summing bonus payment values
                    TicketIdApuestaVirtual: ["TicketIdApuestaVirtual"], // Summing bonus payment values
                    ClienteIdPlataforma:    ["ClienteIdPlataforma"], // Summing client id values
                    PuntoId: ["PuntoId"], // Summing point id
                },
            });
        });
        var filter = ''; // Variable to hold filter string
        this.on(this.app, 'flujoCaja:filter', (filterData) => {
            var object = Object.entries(filterData); // Convert filter data to entries
            var string1 = ''; // Initialize filter string
            for (var i = 0; i < object.length; i++) {
                if (typeof object[i][1] !== 'object' && object[i][1] !== '') {
                    if (object[i][0] == 'Datepicker') {
                        var date = object[i][1].split(' - '); // Split date range
                        string1 = string1 + '&dateFrom=' + date[0]; // Add start date to filter string
                        string1 = string1 + '&dateTo=' + date[1]; // Add end date to filter string
                    } else {
                        if (object[i][0] != 'Date') {
                            string1 = string1 + '&' + object[i][0] + '=' + object[i][1]; // Add other filters to string
                        } else {
                            if (object[i][0] == 'Date') {
                                var date = object[i][1].replace(' 00:00:00', ''); // Clean date string
                                string1 = string1 + '&dateFrom=' + date; // Add date to filter string
                                string1 = string1 + '&dateTo=' + date; // Add date to filter string
                            }
                        }
                    }
                } else {
                    if (typeof object[i][1] === 'object') {
                        var object2 = Object.entries(object[i][1]); // Convert nested filter data to entries
                        for (var j = 0; j < object2.length; j++) {
                            if (object2[j][1] !== null) {
                                if (object2[j][0] === 'start') {
                                    var d = new Date(object2[j][1]); // Create date object for start date
                                    var dateFrom =
                                        'dateFrom=' +
                                        d.getFullYear() +
                                        ':' +
                                        ('00' + (d.getMonth() + 1)).slice(-2) +
                                        ':' +
                                        ('00' + d.getDate()).slice(-2) +
                                        ' ' +
                                        ('00' + d.getHours()).slice(-2) +
                                        ':' +
                                        ('00' + d.getMinutes()).slice(-2) +
                                        ':' +
                                        ('00' + d.getSeconds()).slice(-2); // Format start date
                                    string1 = string1 + '&' + dateFrom; // Add start date to filter string
                                } else {
                                    if (object2[j][0] === 'end') {
                                        var d = new Date(object2[j][1]); // Create date object for end date
                                        var dateTo =
                                            'dateTo=' +
                                            d.getFullYear() +
                                            ':' +
                                            ('00' + (d.getMonth() + 1)).slice(-2) +
                                            ':' +
                                            ('00' + d.getDate()).slice(-2) +
                                            ' ' +
                                            ('00' + d.getHours()).slice(-2) +
                                            ':' +
                                            ('00' + d.getMinutes()).slice(-2) +
                                            ':' +
                                            ('00' + d.getSeconds()).slice(-2); // Format end date
                                        string1 = string1 + '&' + dateTo; // Add end date to filter string
                                    }
                                }
                            }
                        }
                    }
                }
            }
            grid.clearAll(); // Clear existing grid data
            grid.load(url + '?start=0&count=' + grid.data.$pagesize + string1); // Load new data with filters
            $$('filterPopup').hide(); // Hide filter popup
            filter = string1; // Update filter variable
        });
        grid.attachEvent('onAfterSort', function (by, dir, as) {
            grid.load(
                url + '?start=0&count=' + grid.data.$pagesize + filter + '&sort[' + by + ']=' + dir, // Load data after sorting
            );
        });
        grid.attachEvent('onItemClick', function (id, e, node) {
            var item = this.getItem(id); // Get the clicked item
            this.$scope.app.callEvent('user:id', [item.Id]); // Trigger user ID event
        });
        this.on(this.app, 'player:select', (Id) => {
            grid.load(
                grid.data.url + '?start=0&count=' + grid.data.$pagesize + '&PlayerId=' + Id, // Load data based on selected player ID
            );
        });
    }
}

// FILE DOCUMENTED
